import React, { useState, useEffect } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import * as lib from '~/dependencies';
import { BoxDev } from './styles';

export default function Developer({ system, activeDevMode, activeConsole }) {
  const [isDevtools, setIsDevtools] = useState(false);

  function handleOpenDevtools() {
    if (window.isElectron) {
      window.ipcRenderer.send('changeDevtoolsState', !isDevtools);
      setIsDevtools(!isDevtools);
    }
  }

  useEffect(() => {
    if (window.isElectron) {
      const isOpened = window.ipcRenderer.sendSync('getDevtoolsState');
      setIsDevtools(isOpened);
    }
  }, [setIsDevtools]);

  return (
    <BoxDev>
      <FormControlLabel
        control={
          <Switch
            checked={system.dev}
            onChange={() => activeDevMode(!system.dev)}
            value={system.dev}
            color="primary"
          />
        }
        label={
          system.dev ? 'Development server is ON' : 'Development server is OFF'
        }
      />
      <FormControlLabel
        control={
          <Switch
            checked={system.console}
            onChange={() => activeConsole(!system.console)}
            value={system.console}
            color="primary"
          />
        }
        label={system.console ? 'Console logs are ON' : 'Console logs are OFF'}
      />
      <FormControlLabel
        control={
          <Switch
            checked={isDevtools}
            onChange={() => handleOpenDevtools()}
            value={isDevtools}
            color="primary"
          />
        }
        label={isDevtools ? 'Devtools is ON' : 'Devtools is OFF'}
      />
    </BoxDev>
  );
}

Developer.defaultProps = {
  system: [],
  activeDevMode: () => {},
  activeConsole: () => {},
};

Developer.propTypes = {
  system: lib.PropTypes.instanceOf(Object),
  activeDevMode: lib.PropTypes.func,
  activeConsole: lib.PropTypes.func,
};
